var map = {
	"../dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard-dashboard-module"
	],
	"./admin/admin.module": [
		"./src/app/cpos-modules/admin/admin.module.ts",
		"default~admin-admin-module~auth-auth-module",
		"common",
		"admin-admin-module"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"default~auth-auth-module~vendor-vendor-module",
		"default~admin-admin-module~auth-auth-module",
		"default~auth-auth-module~cpos-modules-cpos-module",
		"auth-auth-module"
	],
	"./barcode/barcode.module": [
		"./src/app/cpos-modules/barcode/barcode.module.ts",
		"barcode-barcode-module"
	],
	"./cpos-modules/cpos.module": [
		"./src/app/cpos-modules/cpos.module.ts",
		"default~auth-auth-module~cpos-modules-cpos-module",
		"cpos-modules-cpos-module"
	],
	"./master/master.module": [
		"./src/app/cpos-modules/master/master.module.ts",
		"master-master-module"
	],
	"./reports/reports.module": [
		"./src/app/cpos-modules/reports/reports.module.ts",
		"reports-reports-module"
	],
	"./vendor/vendor.module": [
		"./src/app/cpos-modules/vendor/vendor.module.ts",
		"default~auth-auth-module~vendor-vendor-module",
		"vendor-vendor-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;